function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 158,
  cy: 539.7,
  fill: "#e6e6e6",
  rx: 158,
  ry: 12
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M121 122c27-11 62-4 95 1 0-6 4-14 0-18-5-5-4-11-1-16 7-15-4-30-14-42a24 24 0 00-20-9l-20 2a24 24 0 00-21 17c-5 6-7 13-6 19-7 5-8 11-5 17 3 4 3 8 0 12a56 56 0 00-8 17zM774 477H214a19 19 0 01-19-19q305-35 598 0a19 19 0 01-19 19z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M793 459l-598-1 69-116 1-1V84a24 24 0 0123-24h408a24 24 0 0124 24v259z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M288 77a8 8 0 00-8 8v234a8 8 0 008 8h412a8 8 0 008-8V85a8 8 0 00-8-8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M290 358a3 3 0 00-3 2l-22 46a3 3 0 003 5h449a3 3 0 003-5l-23-47a3 3 0 00-3-1z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 492.3,
  cy: 68,
  r: 5,
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M448 419a3 3 0 00-3 3l-5 20a3 3 0 003 4h102a3 3 0 003-4l-7-20a3 3 0 00-3-3zM720 337v5H264l1-1v-4h455z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 707.3,
  cy: 77.4,
  r: 77.4,
  fill: "#514adc"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M739 111h-64a4 4 0 01-4-4V68a4 4 0 014-4h64a4 4 0 015 4v39a4 4 0 01-5 4zm-64-43v39h64V68z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M727 68h-40V50c0-13 9-22 20-22s20 9 20 22zm-35-4h31V50c0-10-7-17-16-17s-15 7-15 17z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 707.3,
  cy: 86.2,
  r: 4.4,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M653 247H335a6 6 0 01-6-6v-79a6 6 0 016-6h318a6 6 0 016 6v79a6 6 0 01-6 6zm-318-88a4 4 0 00-4 3v79a4 4 0 004 4h318a4 4 0 004-4v-79a4 4 0 00-4-3z"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 384.2,
  cy: 198.7,
  r: 24,
  fill: "#e6e6e6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M440 183a4 4 0 100 8h189a4 4 0 000-8zM440 207a4 4 0 100 8h81a4 4 0 100-8z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M264 208l-59 32-1-26c19-4 37-9 54-18l6-16a10 10 0 0118-2 10 10 0 01-1 14z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M120 389a12 12 0 011-9l13-20a23 23 0 0129-8c-5 9-4 18 2 25a118 118 0 00-28 19 12 12 0 01-17-7z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M266 363a22 22 0 01-19 11l-86 1-3-22 38-11-32-25 35-41 63 60a22 22 0 014 27z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M148 511h-20c-18-124-37-248 18-294l64 10-8 54-36 41z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M166 539a12 12 0 01-10-1l-22-3a23 23 0 01-7-30c9 6 17 5 24-2 5 11 13 10 21 18a12 12 0 01-6 18z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M196 134l-38-9c7-13 7-27 4-42l25-1c1 19 4 36 9 52z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#514adc",
  d: "M206 249c-27 19-46 1-61-27 2-16-1-37-7-58a40 40 0 0124-49l32 14c27 22 33 46 23 71z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M128 152l-30 16 53 31 7 19a10 10 0 01-5 12 10 10 0 01-13-8l-1-13-67-22a16 16 0 01-10-10 16 16 0 016-18l54-37z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#514adc",
  d: "M158 155c-13-5-24 1-38 6l-3-40c15-7 28-10 41-4z"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 172.5,
  cy: 78.1,
  r: 23.8,
  fill: "#ffb8b8"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M201 75c-24 2-42-1-53-12v-9h51z"
});

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 793 551.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.43e3dc0a.svg";
export { ForwardRef as ReactComponent };